var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_BlockLeavePolicy_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-block-leave-policy-group"),
      filterable: "",
      exportBtn: _vm.hasBtn("export-admin-block-leave-policy-group"),
      importBtn: _vm.hasBtn("import-admin-block-leave-policy-group"),
      "import-options": {
        api: "/block-leave-group/import/",
        templateUrl:
          "https://assets.essencehr.io/web/ess-business/assets/block-leave-group-import-template.xlsx",
        success: function (result) {
          _vm.getList(null, 1, _vm.$tableSetting.perPageSize, function () {
            _vm.$store.dispatch("resetTable", new Date().getTime())
          })
        },
      },
    },
    on: {
      new: _vm.toNew,
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.onExport,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                items: _vm.desserts,
                "filter-page-data": _vm.filterPageData,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.block_leave_group_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "text--primary table-title",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.block_leave_group_name
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.block_leave_group_name
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.block_leave_group_code",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(" " + _vm._s(item.block_leave_group_code) + " "),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn(
                            "delete-admin-block-leave-policy-group"
                          ),
                          viewBtn: _vm.hasBtn(
                            "view-admin-block-leave-policy-group"
                          ),
                          editBtn: _vm.hasBtn(
                            "edit-admin-block-leave-policy-group"
                          ),
                          title: _vm.$t(
                            "label_essweb_BlockLeavePolicy_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }